import styles from './BroadcasterVideoComponent.module.scss';
import { useRouter } from 'next/router';
import useSWRImmutable from 'swr/immutable';
import { getVideos } from '@/api';
import { formatDuration, timeAgo } from '@/utils/common';


const BroadcasterVideoComponent: React.FC = () => {
    const router = useRouter();

    const { data: getVideosData } = useSWRImmutable(
        'videos',
        async () => {
            const res = await getVideos();
            // console.log('API response:', res); // ✅ check shape
            return res.videos;
        }
    );

    const handleVideoClick = (video: any) => {
        router.push({
            pathname: '/broadcaster/player',
            query: { id: video.id }
        });
    };
    return (
        <div className={styles.videoGrid}>
            {getVideosData?.map((video, index) => (
                <div
                    key={index}
                    className={styles.cardsss}
                    onClick={() => handleVideoClick(video)}
                    style={{ cursor: 'pointer' }}
                >
                    <div className={styles.thumbnailWrapper} >
                    <video className={styles.thumbnail} poster={video.thumbnail} width="100%" muted>
                        <source src={video.url} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                    <span className={styles.timestamp}>{formatDuration(video.duration)}</span>
                    </div>
                    <div className={styles.cardContent}>
                        <div className={styles.videoTitle}>{video.title}</div>
                        <div className={styles.subtitle}>{video.viewsCount} &nbsp;Views • {timeAgo(video.createdAt)}</div>

                    </div>
                </div>
            ))}
        </div>
    );
};

export default BroadcasterVideoComponent;
